import React, { useContext, useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Menu, Icon, Accordion } from 'semantic-ui-react';
import { SettingMenuContext } from './content';
import { redirectToInternalLink } from 'businessLogic/redirector';
import { getCallQualityProfiles } from 'actions/portalSetting';
import { resetMeetingRoomForm } from 'actions/meetingRoom';
import {
  getOrgUnitGeneralInfo,
  getOrgUnitSupportContactInfo,
  updateOrganisationalUnitLogoImageForm,
  getOrganisationById,
  getOrgUnitBeforeCallsForWA,
  getOrgUnitWithSearchTerm,
  updateFilterValue,
  getShareLinkMessageForWA,
  getOURecordingSetting,
  getShortUrls,
  getDefaultGCSettingsForOU,
} from '../../../../actions/organisation';
import {
  updateShowCreateWaitingAreaModal,
  updateShowCreateMeetingRoomModal,
  showOrgUnitGeneralInfoModal,
  showOrgUnitSupportContactModal,
  showOrgUnitBeforeCallsForWA,
  showOrganisationalUnitLogoImageModal,
  showOrgUnitShareLinkForWAModal,
  showOURecordingSettingModal,
  showGCSettingsModal,
  showOuDefaultGcSettingsModal,
  showDeleteOrganizationModal,
} from 'actions/modal';
import { getGCWASettings, getWaitingAreaCreateSettings, setCreateWAForm } from '../../../../actions/waitingArea';

// Org level admin functions
function createWA(org, filterValue, dispatch) {
  let cb = (data) => {
    dispatch(updateShowCreateWaitingAreaModal(true));
    dispatch(setCreateWAForm(data));
  };
  if (filterValue === 1) {
    dispatch(getWaitingAreaCreateSettings(org.networkId, cb));
  } else if (filterValue === 2 || filterValue === 3) {
    dispatch(getOrgUnitWithSearchTerm(org.networkId, cb));
  }
}

function deleteOrg(dispatch) {
  dispatch(showDeleteOrganizationModal(true));
}

function createMR(org, dispatch) {
  let cb = () => {
    dispatch(resetMeetingRoomForm());
    dispatch(updateShowCreateMeetingRoomModal(true));
  };
  dispatch(getCallQualityProfiles(cb));
}

function defaultGCSettingsForOU(orgId, dispatch) {
  let cb = () => {
    dispatch(showOuDefaultGcSettingsModal(true));
  };
  dispatch(getDefaultGCSettingsForOU(orgId, cb));
}

function manageReportingTags(org, filterValue, dispatch) {
  dispatch(updateFilterValue(filterValue));
  redirectToInternalLink('organisational-unit/manage-tags/' + org.networkId);
}
function manageUsers(org, filterValue, dispatch) {
  dispatch(updateFilterValue(filterValue));
  redirectToInternalLink('organisational-unit/manage-users/' + org.networkId);
}

function editGeneralInfo(org, dispatch) {
  //Edit General Info Work
  let cb = () => {
    dispatch(showOrgUnitGeneralInfoModal(true));
  };
  dispatch(getShortUrls());
  dispatch(getOrgUnitGeneralInfo(org.networkId, cb));
}

function viewSupportContact(org, dispatch) {
  let cb = () => {
    dispatch(showOrgUnitSupportContactModal(true));
  };
  dispatch(getOrgUnitSupportContactInfo(org.networkId, cb));
}

function editOrgLogo(org, dispatch) {
  let cb = (returnedOrgUnit) => {
    let orgUnit = returnedOrgUnit || org;

    dispatch(
      updateOrganisationalUnitLogoImageForm({
        orgLogoUrl: orgUnit.orgLogoUrl,
        isChanged: false,
      })
    );
    dispatch(showOrganisationalUnitLogoImageModal(true));
  };
  dispatch(getOrgUnitWithSearchTerm(org.networkId, cb));
}

function viewWaitingAreasBeforeCalls(org, dispatch) {
  let cb = () => {
    dispatch(showOrgUnitBeforeCallsForWA(true));
  };
  dispatch(getOrgUnitBeforeCallsForWA(org.networkId, cb));
}

function viewWaitingAreasShareLink(org, dispatch) {
  let cb = () => {
    dispatch(showOrgUnitShareLinkForWAModal(true));
  };
  dispatch(getShareLinkMessageForWA(org.networkId, cb));
}
function openOURecordingSettingModal(org, dispatch) {
  let successGetOURecord = () => {
    dispatch(showOURecordingSettingModal(true));
  };
  dispatch(getOURecordingSetting(org.networkId, successGetOURecord));
}
// Org setting menu
export default function OrgSettingMenu(props) {
  const dispatch = useDispatch();
  const { waSetting, orgSetting, entityFilter, selectedOrgUnit, openSubMenu } = useContext(SettingMenuContext);
  const [openOrgSettingMenu, setOpenOrgSettingMenu] = orgSetting;
  const [settingSubMenuActiveIndex, setSettingSubMenuActiveIndex] = openSubMenu;
  const [filterValue, setFilterValue] = entityFilter;

  const ouGcSettings = useSelector((state) => state.organisationsReducer.ouGcSettings);

  let hasEditOrgAccess = false;
  let hasCreateOrgAccess = false;
  let hasCreateMROrgAccess = false;
  let hasViewTagsAccess = false;
  let hasDeleteAccess = false;

  const isChatFeatureEnabled = props.isChatFeatureEnabled;
  const isFullNameFeatureEnabled = props.isFullNameFeatureEnabled;

  if (selectedOrgUnit) {
    hasViewTagsAccess =
      selectedOrgUnit.reportingTagsEnabled &&
      selectedOrgUnit.permissions &&
      selectedOrgUnit.permissions.indexOf(APP.LANGUAGE.Org_Permission.VIEW_ASSIGNED_TAGS) > -1;
    if (selectedOrgUnit.permissions) {
      hasDeleteAccess =
        selectedOrgUnit.permissions.indexOf(APP.LANGUAGE.Org_Permission.DELETE) > -1 &&
        ((props.entityAdminRights.isAdmin && !props.entityAdminRights.isSystemAdmin) ||
          (props.entityAdminRights.isSystemAdmin && props.entityAdminRights.isSysAdminAllowedToDeleteOrg));
      hasEditOrgAccess = selectedOrgUnit.permissions.indexOf('EDIT') > -1;
      hasCreateOrgAccess = selectedOrgUnit.permissions.indexOf('CREATE_WAITING_AREA') > -1;
      hasCreateMROrgAccess = selectedOrgUnit.permissions.indexOf('CREATE_MEETING_ROOM') > -1;
    }
  }

  const subMenu = (
    <Menu vertical className="color-white new-advanced-settings-menu color-organisational-unit-dark-bg pdbm mrtnull">
      <Menu.Item
        className="standard-menu-font-size"
        onClick={() => {
          editGeneralInfo(selectedOrgUnit, dispatch);
        }}
      >
        {APP.LANGUAGE.ViewOrgUnit.EditGeneralInfo}
      </Menu.Item>
      <Menu.Item
        className="standard-menu-font-size"
        onClick={() => {
          viewSupportContact(selectedOrgUnit, dispatch);
        }}
      >
        {APP.LANGUAGE.ViewOrgUnit.DefaultSupportContact}
      </Menu.Item>
      <Menu.Item
        className="standard-menu-font-size"
        onClick={() => {
          editOrgLogo(selectedOrgUnit, dispatch);
        }}
      >
        {APP.LANGUAGE.ViewOrgUnit.DefaultOrgLogoAction}
      </Menu.Item>
      {props.isRecordingFeatureEnabled && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openOURecordingSettingModal(selectedOrgUnit, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOrgUnit.AudioRecording}
        </Menu.Item>
      )}
      <Menu.Item
        className="standard-menu-font-size"
        onClick={() => {
          viewWaitingAreasBeforeCalls(selectedOrgUnit, dispatch);
        }}
      >
        {APP.LANGUAGE.ViewOrgUnit.WaitingAreasBeforeCalls}
      </Menu.Item>
      <Menu.Item
        data-show={props.isWAEntryPointAdditionalMsgAllowed}
        className="standard-menu-font-size"
        onClick={() => {
          viewWaitingAreasShareLink(selectedOrgUnit, dispatch);
        }}
      >
        {APP.LANGUAGE.ViewOrgUnit.WaitingAreasShareLink}
      </Menu.Item>
      {isChatFeatureEnabled || isFullNameFeatureEnabled ? (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            defaultGCSettingsForOU(selectedOrgUnit.networkId, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOrgUnit.GCSettings}
        </Menu.Item>
      ) : (
        ''
      )}
    </Menu>
  );

  return (
    <React.Fragment>
      {openOrgSettingMenu && (
        <div id="entity-admin-setting-menu" className="advanced-settings">
          <Menu
            className="new-advanced-settings-menu color-organisational-unit-bg pdbnull take-remain-space flex-direction-column"
            vertical
          >
            <Menu.Header
              className={
                'inline-flex center-flex pdtm pdbm space-between max-width ' +
                (props.isOnMobileOrTablet ? 'pdlm pdrm pdtm pdbm' : 'pdll pdrml')
              }
            >
              <div>
                <div className="color-white mrrs mrbxxs">{APP.LANGUAGE.EntityAdmin.Title.replace('Units', 'Unit')}</div>
                <div className="color-white bold mrrs setting-menu-header wrap-link">
                  {APP.LANGUAGE.EntityAdmin.Settings.replace('##entityName##', selectedOrgUnit.name)}
                </div>{' '}
              </div>
              {props.isOnMobileOrTablet ? (
                <div className="pdxs hand" onClick={props.closeMenu}>
                  <Icon name="cancel" className="color-footer-links mrrnull close-menu-icon" size="large" />
                </div>
              ) : (
                <div style={{ width: '38px', height: '40px' }} />
              )}
            </Menu.Header>
            {hasCreateOrgAccess && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  createWA(selectedOrgUnit, filterValue, dispatch);
                }}
              >
                {APP.LANGUAGE.ViewOrgUnit.CreateWaitingAreaAction}
              </Menu.Item>
            )}
            {hasCreateMROrgAccess && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  createMR(selectedOrgUnit, dispatch);
                }}
              >
                {APP.LANGUAGE.ViewOrgUnit.CreateMeetingRoomAction}
              </Menu.Item>
            )}
            {selectedOrgUnit.permissions.indexOf(APP.LANGUAGE.Org_Permission.MANAGE_USERS) > -1 && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  manageUsers(selectedOrgUnit, filterValue, dispatch);
                }}
              >
                {APP.LANGUAGE.ViewOrgUnit.ManageUserAction}
              </Menu.Item>
            )}
            {hasViewTagsAccess && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  manageReportingTags(selectedOrgUnit, filterValue, dispatch);
                }}
              >
                {APP.LANGUAGE.ViewOrgUnit.ReportTagAction}
              </Menu.Item>
            )}
            {hasDeleteAccess && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  deleteOrg(dispatch);
                }}
              >
                {APP.LANGUAGE.ViewOrgUnit.DeleteOrganisationalUnit}
              </Menu.Item>
            )}
            {hasEditOrgAccess && (
              <Accordion
                as={Menu}
                vertical
                className="mrtnull new-advanced-settings-menu color-organisational-unit-bg pdbnull take-remain-space flex-direction-column"
              >
                <Menu.Item className="pdlnull pdrnull pdbnull pdtnull take-remain-space flex-direction-column">
                  <Accordion.Title
                    className={
                      'color-white standard-menu-font-size menu-item-org ' +
                      (props.isOnMobileOrTablet ? 'pdlm pdrm' : 'pdll pdrl')
                    }
                    active={settingSubMenuActiveIndex === 0}
                    index={0}
                    onClick={props.handleClick}
                  >
                    {APP.LANGUAGE.ViewOrgUnit.Properties}
                    {settingSubMenuActiveIndex === 0 ? (
                      <Icon name="angle up" className="arrow-rotate-up fr" />
                    ) : (
                      <Icon name="angle down" className="arrow-rotate-down fr" />
                    )}
                  </Accordion.Title>
                  <Accordion.Content
                    className={'pdtnull ' + (settingSubMenuActiveIndex === 0 ? 'take-remain-space' : '')}
                    active={settingSubMenuActiveIndex === 0}
                    content={subMenu}
                  />
                </Menu.Item>
              </Accordion>
            )}
          </Menu>
        </div>
      )}
    </React.Fragment>
  );
}
